import { API } from './resources'

export default {
  link: (projectID, url, key) => {
    return API.post('/upload/link', { projectID, url, key })
  },
  header: (url) => {
    return API.get('/upload/header', { params: { url } })
  },
  image: (projectID, url, key) => {
    return API.post('/upload/image', { projectID, url, key })
  },
  file: (projectID, url, key) => {
    return API.post('/upload/file', { projectID, url, key })
  },
  linkV3: (url) => {
    return API.post('/upload/link/v3', { url })
  },
  iframeV3: (url) => {
    return API.post('/upload/iframe/v3', { url })
  },
  imageV3: (url, key) => {
    return API.post('/upload/image/v3', { url, key })
  },
  fileV3: (url, key) => {
    return API.post('/upload/file/v3', { url, key })
  },
  whiteboardV3: (url, key) => {
    return API.post('/upload/whiteboard/v3', { url, key })
  },
  video: async (file, trace, width, height, callback) => {
    const formData = new FormData()

    formData.append('traceId', trace)
    formData.append('width', width)
    formData.append('height', height)
    formData.append('video', file, file.name.normalize('NFD').replace(/[\u0300-\u036f]/g, ''))

    const staging = process.env.STAGING === 'true' || process.env.QA === 'true' || process.env.PP === 'true'
    const isMakeSite = process.env.APP_NAME === 'Make' || process.env.APP_NAME === 'Heise'
    const baseURL = (isMakeSite && process.env.NODE_ENV === 'production' && !staging) ? 'https://videos.projectboard.world' : process.env.API_ROOT

    return API.post('/upload/video', formData, {
      baseURL: baseURL,
      headers: {
        'Access-Control-Allow-Origin': process.env.WEB_ROOT,
        'Content-Type': 'multipart/form-data',
        'X-Content-Name': file.name.normalize('NFD').replace(/[\u0300-\u036f]/g, ''),
        'X-Content-Length': file.size
      },
      onUploadProgress: function (progressEvent) {
        callback(parseInt(Math.round((progressEvent.loaded / file.size) * 100), 10))
      }
    })
  }
}
